(() => {
  'use strict';

  const init = () => {
    const root = document.querySelector('[data-skw-main-page]');
    if (!root || root.dataset.skwInitialized === 'true') return;
    root.dataset.skwInitialized = 'true';
    const handle = root.dataset.skwPageHandle || '';

    const releaseScrollLocks = () => {
      if (handle !== 'ferienraetsel-nrw-2026') return;
      [document.documentElement, document.body].forEach((element) => {
        if (!element) return;
        element.style.setProperty('height', 'auto', 'important');
        element.style.setProperty('min-height', '100%', 'important');
        element.style.setProperty('overflow-y', 'auto', 'important');
        element.style.setProperty('overflow-x', 'hidden', 'important');
        element.style.setProperty('position', 'static', 'important');
      });
      const main = document.getElementById('MainContent');
      if (main) {
        main.style.setProperty('height', 'auto', 'important');
        main.style.setProperty('max-height', 'none', 'important');
        main.style.setProperty('overflow', 'visible', 'important');
      }
    };

    releaseScrollLocks();
    window.addEventListener('load', releaseScrollLocks, { once: true });
    window.setTimeout(releaseScrollLocks, 350);
    window.setTimeout(releaseScrollLocks, 1200);

    root.querySelectorAll('.skw-page-content table').forEach((table) => {
      if (table.closest('.skw-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'skw-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Tabelle horizontal scrollen');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);

      const hint = document.createElement('p');
      hint.className = 'skw-table-hint';
      hint.textContent = 'Tabelle: Auf kleinen Bildschirmen seitlich wischen.';
      wrapper.insertAdjacentElement('afterend', hint);

      const updateOverflow = () => { wrapper.dataset.overflow = String(wrapper.scrollWidth > wrapper.clientWidth + 2); };
      requestAnimationFrame(updateOverflow);
      window.addEventListener('resize', updateOverflow, { passive: true });
    });

    document.addEventListener('click', async (event) => {
      const nativeShare = event.target.closest('[data-skw-native-share]');
      if (nativeShare) {
        const title = nativeShare.dataset.shareTitle || document.title;
        const url = nativeShare.dataset.shareUrl || window.location.href;
        const shareRoot = nativeShare.closest('[data-skw-page-share]');
        const copyPrompt = shareRoot?.dataset.copyPrompt || 'Link kopieren:';
        if (navigator.share) {
          try { await navigator.share({ title, url }); }
          catch (error) { if (!error || error.name !== 'AbortError') window.prompt(copyPrompt, url); }
        } else {
          try {
            await navigator.clipboard.writeText(url);
            const status = shareRoot?.querySelector('[data-skw-share-status]');
            if (status) status.textContent = shareRoot?.dataset.copyStatus || 'Link wurde kopiert.';
            nativeShare.textContent = shareRoot?.dataset.nativeCopied || 'Link kopiert';
          } catch (error) { window.prompt(copyPrompt, url); }
        }
        return;
      }

      const copyButton = event.target.closest('[data-skw-copy-link]');
      if (copyButton) {
        const url = copyButton.dataset.shareUrl || window.location.href;
        const shareRoot = copyButton.closest('[data-skw-page-share]');
        const copyPrompt = shareRoot?.dataset.copyPrompt || 'Link kopieren:';
        try {
          await navigator.clipboard.writeText(url);
          copyButton.textContent = shareRoot?.dataset.copyDone || 'Kopiert';
          const status = shareRoot?.querySelector('[data-skw-share-status]');
          if (status) status.textContent = shareRoot?.dataset.copyStatus || 'Link wurde kopiert.';
        } catch (error) { window.prompt(copyPrompt, url); }
      }
    });

    const backToTop = document.querySelector('[data-skw-back-to-top]');
    if (backToTop) {
      const updateBackToTop = () => {
        const longPage = document.documentElement.scrollHeight > window.innerHeight * 2.2;
        backToTop.dataset.visible = String(longPage && window.scrollY > 700);
      };
      backToTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      updateBackToTop();
      window.addEventListener('scroll', updateBackToTop, { passive: true });
      window.addEventListener('resize', updateBackToTop, { passive: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
